// src/utils/loadPayPalSdk.js
export const loadPayPalSdk = (clientId) => {
  const scriptUrl = `https://www.paypal.com/sdk/js?client-id=${clientId}&components=buttons,marks,funding-eligibility&currency=USD&intent=capture&vault=true`;

  const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

  // Check if the script is already loaded to avoid duplicates
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    script.onload = () => {};
    script.onerror = () => {
      console.error('Failed to load PayPal SDK');
    };
    document.body.appendChild(script);
  }
};
